import { AppState, AppThunkDispatch } from '..';
import RemoteFlash from '../../services/remote-flash';
import { GetFirmwareStatusRequest } from '../../services/types';
import { RemoteFlashActionNames } from './remote-flash/types';
import { ConfigurationActions } from './software/types';
import {
  State as FirmwareStateType,
  Status as FirmwareStatusType,
} from '../../entities/remote-flash-v1/models';

export const getSoftwareStatusByDeviceKey =
  (input: GetFirmwareStatusRequest) =>
    async (dispatch: AppThunkDispatch, getState: () => AppState) => {
      const {
        login: { client, envVariables },
      } = getState();
      const remoteFlashService = new RemoteFlash(client, envVariables.remoteFlashV1BaseUrl);
      try {
        const response = await remoteFlashService.getFirmwareStatus(input);
        if (response?.data?.firmware?.status === FirmwareStatusType.FlashFileCorrupt) {
          response.data.firmware.state = FirmwareStateType.ReadyToFlash;
        }
        dispatch({
          type: RemoteFlashActionNames.SET_FIRMWARE_STATUS,
          payload: response.data?.firmware,
        });
      } catch (error: any) {
        let firmware: any = {};
        firmware = error.response.data;
        firmware = firmware?.state === FirmwareStateType.ReadyToFlash ? { state: firmware?.state, status: "N/A" } : {};
        dispatch({
          type: RemoteFlashActionNames.SET_FIRMWARE_STATUS,
          payload: firmware,
        });
      }
    };


export const setIsDownloadButtonDisabled = (isDownloadButtonDisabled: boolean) =>
  async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    dispatch({
      type: ConfigurationActions.SET_IS_DOWNLOAD_BUTTTON_DISABLED,
      payload: isDownloadButtonDisabled,
    });
  };
